import { render } from "./newTask.vue?vue&type=template&id=176c5d79"
import script from "./newTask.vue?vue&type=script&lang=js"
export * from "./newTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__